(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('SelecaoAreaDemarcadaCtrl', SelecaoAreaDemarcadaCtrl);

  SelecaoAreaDemarcadaCtrl.$inject = [
    '$uibModalInstance',
    '$scope',
    'areas',
    'DrawPolygonsObjectService'
  ];

  function SelecaoAreaDemarcadaCtrl($uibModalInstance, $scope, areas, DrawPolygonsObjectService) {
    const vm = this;
    vm.areas = areas;

    vm.confirm = function(area) {
      $uibModalInstance.close(area);
    };

    function init() {
      const pontos = _.flatMap(_.flatMap(areas, 'coordenadas'), 'pontos');
      const pontosLeaflet = pontos.map((ponto) => [+ponto.latitude, +ponto.longitude]);
      const bounds = L.bounds(pontosLeaflet);
      vm.bounds = [
        [bounds.getBottomLeft().x, bounds.getBottomLeft().y],
        [bounds.getTopRight().x, bounds.getTopRight().y]
      ];
    }
    init();

    function resetColors() {
      vm.polygons.forEach((polygon) => {
        polygon.setStyle({
          color: vm.originalColor
        });
      });
    }

    $scope.$on('leafletMapComplete', (_event, map) => {
      vm.map = map;
      vm.map.removeControl(vm.map.zoomControl);
      vm.polygons = [];
      areas.forEach((area) => {
        const { polygons } = DrawPolygonsObjectService.convertToObjectLeaflet(area);
        vm.polygons = vm.polygons.concat(polygons);
        polygons.forEach((polygon) => {
          if (!vm.originalColor) {
            vm.originalColor = polygon.options.color;
          }
          polygon.addTo(vm.map);
          polygon.areaId = area.id;
          polygon.on('click', (event) => {
            const { target } = event;
            resetColors();
            vm.selecionada = area;
            target.setStyle({
              color: '#FFF'
            });
            $scope.$apply();
          });
        });
      });
    });

    $scope.$on('$destroy', () => vm.map.remove());
  }
}());
